// extracted by mini-css-extract-plugin
export default {"title":"M_-z","warning":"N_-z","sizeOptionsLegendText":"O_-z"};